<div class="branded-asset-cover">
	<div class="middle">
		<div class="floating-entry">
			<div class="branded-asset-logo"></div>
		</div>
		<div class="floating-entry">
			<div class="input-bounder">
				<form *ngIf="!success" (ngSubmit)="Forgot()">
					<div class="form-group">
						<label for="email">Email address</label>
						<input [(ngModel)]="email" name="email" type="email" id="email" class="form-control">
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-success">Reset Password</button>
					</div>
				</form>
				<div *ngIf="success">
					<div>If {{email}} is a valid user, then a password reset email will be sent to that address. Follow the link in the email
						to reset your password.</div>
					</div>
				<div *ngIf="errormessage" class="message-bad">{{errormessage}}</div>
				<div class="forgot-link mt-4"><a [routerLink]="['/login']">Return to login</a></div>
			</div>
		</div>
	</div>
</div>